import { Check, Loader2 } from "lucide-react";

const PROCESSING_STEPS = [
  "crawling",
  "parsing",
  "chunking",
  "embedding",
  "extracting",
] as const;

interface ProcessingStepperProps {
  currentStep?: string;
}

export function ProcessingStepper({ currentStep }: ProcessingStepperProps) {
  const activeIdx = PROCESSING_STEPS.indexOf(
    currentStep as (typeof PROCESSING_STEPS)[number],
  );

  return (
    <div className="flex items-center gap-1 text-xs">
      {PROCESSING_STEPS.map((step, i) => {
        const isDone = activeIdx > i;
        const isActive = activeIdx === i;
        return (
          <div key={step} className="flex items-center gap-1">
            {i > 0 && (
              <div
                className={`h-px w-4 ${isDone ? "bg-mark-helps" : "bg-border"}`}
              />
            )}
            <div className="flex items-center gap-1">
              {isDone && <Check className="size-3 text-finding-helps" />}
              {isActive && (
                <Loader2 className="size-3 animate-spin text-primary" />
              )}
              {!isDone && !isActive && (
                <div className="size-3 rounded-full border border-muted-foreground/30" />
              )}
              <span
                className={
                  isDone
                    ? "text-finding-helps"
                    : isActive
                      ? "font-medium text-primary"
                      : "text-muted-foreground"
                }
              >
                {step.charAt(0).toUpperCase() + step.slice(1)}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
